import { setSecureAuthData } from './actions';

import store from 'state/store';

export default {
    setSecureAuthData: formData => store.dispatch(setSecureAuthData(formData)),
};
